import { Partner } from "src/types/Partner";

export default function isPartnerGuard(obj: unknown): obj is Partner {
  if (typeof obj !== "object" || obj === null) return false;

  const staff = obj as Partner;

  return (
    typeof staff.uid === "string" &&
    (typeof staff.partnerOrganizationId === "undefined" ||
      typeof staff.partnerOrganizationId === "string") &&
    (typeof staff.referralsImplyJusticeInvolvement === "undefined" ||
      typeof staff.referralsImplyJusticeInvolvement === "boolean") &&
    typeof staff.firstName === "string" &&
    typeof staff.lastName === "string" &&
    typeof staff.email === "string" &&
    (typeof staff.authorizedEmails === "undefined" ||
      (Array.isArray(staff.authorizedEmails) &&
        staff.authorizedEmails.every((email) => typeof email === "string"))) &&
    (typeof staff.dashboardLabel === "undefined" ||
      typeof staff.dashboardLabel === "string") &&
    (typeof staff.dashboardOrder === "undefined" ||
      (typeof staff.dashboardOrder === "number" &&
        Number.isInteger(staff.dashboardOrder) &&
        staff.dashboardOrder >= 0)) &&
    (typeof staff.signupUrl === "undefined" ||
      typeof staff.signupUrl === "string") &&
    typeof staff.phone === "string" &&
    typeof staff.invitationCode === "string" &&
    typeof staff.createdAt === "string"
  );
}
